import baseRequest from './baseRequest';

export function sendData(sessionData) {
  return baseRequest.post('/api/public/sessions', sessionData);
}
